import React from 'react';
import styled, { css } from 'styled-components';

import FormBasicValidationError from '@rover/components/src/formFields/FormValidationError/FormBasicValidationError';
import { Box } from '@rover/kibble/core';
import MQ from '@rover/kibble/styles/MediaQuery';

type InlineErrorDateInputProps = {
  onKeyDown?: (any) => void;
  value: string;
  inputId?: string;
  errorMessage: errorMessageType;
  placeholder?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
};

// errorMessageType needs to accept all translation formats, i.e. t`, <Trans> and i18n strings
export type errorMessageType = JSX.Element | string | null | undefined;

export const DateInput = styled.input<{ errorMessage: errorMessageType }>`
  ${MQ.XS.toString()} {
    &:focus {
      font-size: 16px;
    }
  }
  ${({ errorMessage }) =>
    errorMessage
      ? css`
          border: ${({ theme }) =>
            `${theme.borderWidth.primary} solid ${theme.colors.border.error}`} !important;
        `
      : css`
          border: ${({ theme }) =>
            `${theme.borderWidth.primary} solid ${theme.colors.border.primary}`} !important;
        `}
`;

const InlineErrorDateInput = ({
  errorMessage,
  onKeyDown,
  value,
  inputId,
  placeholder = undefined,
  onClick,
  style,
  ...other
}: InlineErrorDateInputProps): JSX.Element => {
  return (
    <Box role="button" onClick={onClick}>
      <DateInput
        type="text"
        style={{ cursor: 'pointer', ...style }}
        readOnly
        onKeyDown={onKeyDown}
        value={value}
        id={inputId}
        errorMessage={errorMessage}
        placeholder={placeholder}
        aria-labelledby={other['aria-labelledby']}
      />
      {errorMessage && <FormBasicValidationError errorMessage={errorMessage} />}
    </Box>
  );
};

export default InlineErrorDateInput;
